<template>
  <div style="display: flex;flex-direction: column;    height: 100%;">
    <!-- 波形 -->
    <div id="waveform"></div>

    <!-- 音频播放器 -->
    <audio :src="fileUrl" controls style="width: 100%" ref="audioRef" />

    <!-- 时间轴 -->
    <div id="timeline"></div>

    <!-- 缩略图 -->
    <div id="minimap"></div>

    <!-- 标注列表 -->
    <div class="region-list">
      <div
        class="region-item"
        v-for="(item, index) in regionList"
        :key="item.id"
        :style="{ backgroundColor: item.color }"
      >
        <div>{{ index + 1 }}. {{ item.content }}</div>
        <div>
          {{ item.start.toFixed(2) }} - {{ item.end.toFixed(2) }}
          <i class="el-icon-video-play" @click="playRegion(item.region)"></i>
          <i class="el-icon-delete" @click="deleteRegion(item.region)"></i>
        </div>
      </div>
    </div>

    <!-- 右键菜单锚点 -->

    <el-popover
      v-model="popoverVisible"
      :virtual-ref="$refs.popoverRef"
      virtual-triggering
      trigger="manual"
      placement="right-start"
      width="140"
      :show-arrow="false"
    >
      <div
        slot="reference"
        ref="popoverRef"
        class="popover-anchor"
        :style="{ left: menuX + 'px', top: menuY + 'px' }"
      ></div>
      <div class="menu-item" @click="playRegion(clickRegion)">播放</div>
      <div class="menu-item danger" @click="deleteRegion(clickRegion)">
        删除
      </div>
    </el-popover>
  </div>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import RegionsPlugin from "wavesurfer.js/dist/plugins/regions.esm.js";
import TimelinePlugin from "wavesurfer.js/dist/plugins/timeline.esm.js";
import MinimapPlugin from "wavesurfer.js/dist/plugins/minimap.esm.js";
import { Message } from "element-ui";

export default {
  name: "AudioRegionLabel",

  props: {
    value: {
      type: Array,
      default: () => []
    },
    fileUrl: {
      type: String,
      required: true
    },
    labelValue: {
      type: Object,
      required: false
    },
    labelOptions: {
      required: false
    }
  },

  data() {
    return {
      ws: null,
      regions: null,
      regionList: [],

      // 右键菜单
      popoverVisible: false,
      clickRegion: null,
      menuX: 0,
      menuY: 0
    };
  },
  watch: {
    labelOptions: {
      immediate: true,
      deep: true,
      handler(val) {
        const ids = val.map(i => i.label);
        console.log(this.regionList);
        this.regionList.forEach(item => {
          console.log(item.params.label, ids, ids.includes(item.params.label));
          if (!ids.includes(item.params.label)) {
            item.region.remove();
          }
        });
        this.regionList = this.regionList.filter(i =>
          ids.includes(i.params.label)
        );
        this.$emit("input", this.regionList);
      }
    }
  },
  mounted() {
    this.initWaveSurfer();
  },

  beforeDestroy() {
    this.ws && this.ws.destroy();
  },
  methods: {
    hexToRgba(hex, alpha = 0.8) {
      const h = hex.replace("#", "");
      const r = parseInt(h.slice(0, 2), 16);
      const g = parseInt(h.slice(2, 4), 16);
      const b = parseInt(h.slice(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    setOptions(data) {
      data.forEach(item => {
        const region = this.regions.addRegion({
          start: item.start,
          end: item.end,
          content: item.params.label,
          color: this.hexToRgba(item.params.color)
        });

        this.$emit("input", this.regionList);
      });
      console.log(this.regionList);
    },
    initWaveSurfer() {
      this.regions = RegionsPlugin.create();

      const timeline = TimelinePlugin.create({
        container: "#timeline"
      });

      const minimap = MinimapPlugin.create({
        container: "#minimap",
        height: 60,
        interact: true
      });

      this.ws = WaveSurfer.create({
        container: "#waveform",
        url: this.fileUrl,
        minPxPerSec: 10,
        media: this.$refs.audioRef,
        waveColor: "#c6e2ff",
        progressColor: "#409EFF",
        plugins: [this.regions, timeline, minimap]
      });

      // 框选创建
      this.regions.enableDragSelection({
        color: "rgba(115,118,122,0.4)"
      });

      // 创建
      this.regions.on("region-created", region => {
        console.log("region-created");
        if (!this.labelValue) {
          region.remove();
          Message.warning("请先选择标签");
          return;
        }

        if (!region.content || !region.content.textContent) {
          region.setContent(this.labelValue.label);
          region.setOptions({
            color: this.hexToRgba(this.labelValue.color),
            className: "drag-select-region"
          });
        }

        this.regionList.push({
          id: region.id,
          start: region.start,
          end: region.end,
          params: this.labelValue,
          content: region.content.textContent,
          color: region.color,
          region
        });

        this.$emit("input", this.regionList);
      });

      // 更新
      this.regions.on("region-updated", region => {
        const item = this.regionList.find(r => r.id === region.id);
        if (!item) return;
        item.start = region.start;
        item.end = region.end;
        this.$emit("input", this.regionList);
      });

      // 点击（右键 / 左键）
      this.regions.on("region-clicked", (region, e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log(region, e);
        this.showContextMenu(region, e);
      });
    },

    showContextMenu(region, e) {
      this.popoverVisible = false;
      this.clickRegion = region;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.$nextTick(() => (this.popoverVisible = true));
    },

    deleteRegion(region) {
      if (!region) return;
      region.remove();
      this.regionList = this.regionList.filter(r => r.id !== region.id);
      this.popoverVisible = false;
      this.$emit("input", this.regionList);
    },

    playRegion(region) {
      if (!this.ws || !region) return;

      this.ws.pause();
      this.ws.setTime(region.start);

      setTimeout(() => this.ws.play(), 0);

      const handler = time => {
        if (time >= region.end) {
          this.ws.pause();
          this.ws.un("audioprocess", handler);
        }
      };

      this.ws.on("audioprocess", handler);
      this.popoverVisible = false;
    }
  }
};
</script>

<style scoped>
#region,
#waveform,
#timeline,
#minimap {
  margin-top: 8px;
}

.region-list {
  margin-top: 16px;
  flex: 1;
  overflow-y: auto;
}

.region-item {
  display: flex;
  justify-content: space-between;
  padding: 6px;
  margin-bottom: 6px;
  border-radius: 4px;
  color: #fff;
}

.menu-item {
  padding: 6px;
  cursor: pointer;
}
.menu-item:hover {
  background: #f5f7fa;
}
.menu-item.danger {
  color: #f56c6c;
}

.popover-anchor {
  position: fixed;
  width: 0;
  height: 0;
  pointer-events: none;
}

.drag-select-region {
  border-left: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AudioLabel.vue